import axios from 'axios';


export const actionTypes = (typeName, prefix = null) => {
  const name = prefix ? prefix + '_' + typeName : typeName;
  return {
    [typeName]: {
      START: `${name}_START`,
      SUCCESS: `${name}_SUCCESS`,
      ERROR: `${name}_ERROR`,
    },
  };
};


export const instance = axios.create({
  baseURL: `${window.location.origin}/${process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH}`,
  withCredentials: true,
});

export const documentKeys = payload => {

  return Object.keys(payload).filter(
    v => v.startsWith('ben') || v.startsWith('aud') || v.startsWith('obj')
  );
}

export const carrierKeys = payload => {
  const additionalCarrierKeysList = [
    'equipmentType',
    'additionalServices',
    'legalSurname',
    'legalName',
    'legalFather',
    'birthDate',
    'legalAdt',
    'legalVat',
    'abiStreet',
    'abiTk',
    'abiPerfecture',
    'abiDistrict',
    'legalPhoneMobile',
    'legalEmail',
    'legalEmailValidated',
    'ownerStatus',
    'residence',
    'ownerSurname',
    'ownerFirstname',
    'ownerVat',
    'buildStreetBuilding',
    'buildTkBuilding',
    'buildPerfectureBuilding',
    'abiDistrictBuilding',
    'powerNumberBuilding',
    'powerSupply',
    'powerSupplyPrivate',
    'powerSupplyPublic',
    'ameaMember',
    'legalChildren',
    'individualIncome',
    'legalIncome',
    'objCommentBen',
    'vulnerableHousehold',

  ];
  return Object.keys(payload).filter(
    v => v.startsWith('abi') || additionalCarrierKeysList.includes(v)
  );
};

export const AssetKeys = payload =>
  Object.keys(payload).filter(
    v =>
      v.startsWith('businessPlanAssets') || 
      v.startsWith('InvestmentTotalAmountTable') || 
      v.startsWith('businessPlanCoverage') ||
      v.startsWith('mainKads') ||
      v.startsWith('addKads')
  );


export const termsKeys = payload =>
  Object.keys(payload).filter(
    v => v.startsWith('term')
  );

export const auditorKeys = payload =>{
    const additionalAuditorKeysList = [
      'consent',
    ];
    return Object.keys(payload).filter(
      v => v.startsWith('aud') || v.includes('Aud') || additionalAuditorKeysList.includes(v)
    );
}

export const objectionCommitteeKeys = payload =>{
    const additionalObjectionCommitteeKeysList = [
      'consentByCommittee',
    ];
    return Object.keys(payload).filter(
      v => v.includes('ObjCommittee') || additionalObjectionCommitteeKeysList.includes(v)
    );
}

export const supplierKeys = payload =>{
    const additionalSupplierKeysList = [
      // 'consentByCommittee',
    ];
    return Object.keys(payload).filter(
      v => v.includes('voucherInfo') || additionalSupplierKeysList.includes(v)
    );
}

export const xedmKeys = payload =>
  Object.keys(payload).filter(
    v => v.startsWith('details')
  );

export const objectionInvestorKeys = payload => {
  return Object.keys(payload.variables).filter(v => v.startsWith('objInv'));
};

export const projectPlanInfoKeys = payload => {
  const additionalProjectPlanInfoKeysList = ['projectPlans', 'messages', 'timestamp'];
  return Object.keys(payload).filter(v =>
    additionalProjectPlanInfoKeysList.includes(v)
  );
};



